import { types } from './types';
import update from '../../../../utilities/updateStateUtilities';
import isEmpty from 'lodash.isempty';
import { collectionHelper } from '../../../../utilities/basicUtilities';
import { DEFAULT_VOLUME } from '../../../../utilities/storageUtilities';
import { EXPORT_STATUSES } from '../../../../constants/ExportStatuses';

const INITIAL_STATE = {
    isExportsDataLoading: false,
    isVideoViewLoading: false,
    isVideoPresetCreating : false,
    isListCollapsed: true,
    projectName: undefined,
    videoInfo: undefined,
    isVideoInfoLoading: false,
    videoExports: [],
    selectedExport: undefined,
    latestCompletedExportId: undefined,
    videoPlayerVolume: DEFAULT_VOLUME,
    youTubeUploadDialogOpen: false,
    isUploadingToYouTube: false,
    googleAuthDialogOpen: false,
    manageVideoPresetDialogOpen: false,
    googleAuthUrl: undefined,
}

const exportsReducer = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case types.SET_PROPERTY: {
            return update.set(state, action.key, action.value);
        }

        case types.REMOVE_EXPORT_FROM_LIST: {
            var newExports = collectionHelper(state.videoExports).getWhere((ve) => ve.exportId !== action.exportId);
            state = update.set(state, 'videoExports', newExports);
            
            if (!isEmpty(newExports)) {
                if (action.exportId === state.selectedExport.exportId) 
                    state = update.set(state, 'selectedExport', newExports[0]);
            } else {
                state = update.set(state, 'selectedExport', undefined);
            }
            
            return state;
        }

        case types.SET_EXPORT_DELETING_PROGRESS: {
            var modifiedExports = collectionHelper(state.videoExports)
                .updateWhere((ve) => ve.exportId === action.exportId)
                .set((ve) => { ve.isDeleting = action.isDeleting; });
            
            return update.set(state, 'videoExports', modifiedExports);
        }

        case types.SET_EXPORT_STATUS: {
            var modifiedExports = collectionHelper(state.videoExports)
                .updateWhere((ve) => ve.exportId === action.exportId)
                .set((ve) => { 
                    ve.status = action.status;
                    ve.videoFileUrl = action.videoFileUrl;
                    ve.rendererFailureCode = action.rendererFailureCode
                });
               
            if (action.exportId === state.selectedExport.exportId) {
                var selectedExport = collectionHelper(modifiedExports).firstOrDefault((ve) => ve.exportId === action.exportId);
                state = update.set(state, 'selectedExport', {...selectedExport});
            }

            return update.set(state, 'videoExports', modifiedExports);
        }

        case types.UPDATE_EXPORT_PROGRESS: {
            const { exportId, progress } = action;

            if (state.videoExports && state.videoExports.length) {
                const targetExport = state.videoExports.filter(exp => exp.exportId === exportId)[0];
                const targetExportIndex = state.videoExports.indexOf(targetExport);

                if (targetExport) {
                    const modifiedExports = state.videoExports.slice();
                    const updatedVideoExport = { ...targetExport, progress: progress };

                    if (progress.step)
                        updatedVideoExport.status = EXPORT_STATUSES.RUNNING;

                    modifiedExports[targetExportIndex] = updatedVideoExport;
                    
                    if (exportId === state.selectedExport.exportId) {
                        const selectedExport = { ...targetExport, progress: progress };
                        state = update.set(state, 'selectedExport', selectedExport);
                    }
    
                    return update.set(state, 'videoExports', modifiedExports);
                }
            }

            return state;
        }

        case types.UPDATE_EXPORTS_POSITIONS: {
            const { queuePositions } = action;

            if (!state.videoExports || !state.videoExports.length || !queuePositions)
                return state;

            const modifiedExports = state.videoExports.map(videoExport => {
                const exportPositionInfo = queuePositions.find(pos => pos.exportId === videoExport.exportId);
                const newQueuePosition = exportPositionInfo ? exportPositionInfo.position : 0;

                if(!exportPositionInfo) {
                    return {
                        ...videoExport,
                        queuePosition: newQueuePosition
                    };
                } else if (exportPositionInfo.position !== videoExport.queuePosition) {
                    return {
                        ...videoExport,
                        queuePosition: newQueuePosition
                    };
                }

                return videoExport;
            });

            if (state.selectedExport) {
                const exportPositionInfo = queuePositions.find(pos => pos.exportId === state.selectedExport.exportId);
                const newQueuePosition = exportPositionInfo ? exportPositionInfo.position : 0;
                if (!exportPositionInfo) {
                    const selectedExport = { ...state.selectedExport, queuePosition: newQueuePosition };
                    state = update.set(state, 'selectedExport', selectedExport);
                } else if (exportPositionInfo.position !== state.selectedExport.position) {
                    const selectedExport = { ...state.selectedExport, queuePosition: newQueuePosition };
                    state = update.set(state, 'selectedExport', selectedExport);
                }
            }

            return update.set(state, 'videoExports', modifiedExports);
        }

        default: return state;
    }
}

export default exportsReducer;